export default __webpack_public_path__ + "static/media/logo-ekz.3ce3f7cf.png";